import { Reservation } from '../reservation.model';

export class RequestPassengerListStandby {
  departureAirport: string;
  departureDate: string;
  operatingCarrier: string;
  operatingFlightCode: string;

  constructor(reservation: Reservation) {
    const currentSegment = reservation.flightSummary?.currentSegment;
    this.departureAirport = currentSegment?.departureAirport;
    this.departureDate = currentSegment?.departureDateTime?.split('T')[0];
    this.operatingCarrier = currentSegment?.operatingCarrier;
    // CI-23238 (Scenario 1): el codigo de vuelo es obligatorio. Leerlo directo
    // del segmento y usar el parseo de flightNumber solo como respaldo para no
    // enviarlo vacio ni como 'undefined'.
    this.operatingFlightCode =
      currentSegment?.operatingFlightCode ?? this.parseFlightCode(currentSegment?.flightNumber);
  }

  private parseFlightCode(flightNumber?: string): string {
    const parsed = flightNumber?.split(' ')[1];
    return parsed && parsed !== 'undefined' ? parsed : undefined;
  }
}
